import React, {useState} from 'react';
import Nav from './Nav.jsx';
import Footer from './Footer.jsx';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import useFetch from '../Components/UseFetch.jsx';
import {draftQuotes as DQ} from '../HelperFx/datalinks.js';
import Swal from 'sweetalert2';


import verifyToken from '../HelperFx/verifyJwt.js';


const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
  // //Console.log(username);
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';
const filter = '&$filter =';


const CustTable = () => {

  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName,userName, password} = verifyToken(jwttoken);
  //Console.log(custName,userName, password);

  // const customerLink = `${process.env.REACT_APP_API_URL}${customers}`; // Replace with the actual API URL
  const { data: draftQuotes } = useFetch(`${REACT_DATA_URL}${DQ}?${REACT_APP_COMPANY_URL}${filter}sellToCustomerNo${eq}'${custName}'`, token);

  // const { data: customer, loading, error } = useFetch(customerLink, token);
  const draftQuoteInformation = draftQuotes?.value;
  //Console.log(draftQuoteInformation);

  const navigate = useNavigate();

  const data = draftQuoteInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/DraftOrder`, {state: {number: row.no}})}>
          {row.no}
        </span> 
      ),
      sortable: true },
    { name: 'Customer No', selector: row => row.sellToCustomerNo, sortable: true },
    { name: 'Customer Adress', selector: row => row.sellToAddress, sortable: true },
    { name: 'Description', selector: row => row.postingDescription, sortable: true },
    { name: 'Expected Reciept Date', selector: row => row.expectedReceiptDate, sortable: true },
    { name: 'Status', selector: row => row.confirm === true ? 'Processing Confirmed': 'Open', sortable: true },
  ];
  const filteredData = data.filter(item => 
    (item.number?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.customerNo?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (item.WorkDescription?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: '33px',
            },
          },
        }}
      />
    </div>
  );
};



const DraftOrders = () => {

  const navigate = useNavigate();
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName,userName, password} = verifyToken(jwttoken);

  const createDraftQuoteAndNavigateToDraft = async () => {
    const headerResponse = await fetch(`${REACT_DATA_URL}${DQ}?${REACT_APP_COMPANY_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${token}`
      },
      body: JSON.stringify({
        "sellToCustomerNo":custName,
        portalUser: userName,
        documentType:"Quote"
      })
    });

    // //Console.log(headerResponse.statusText)
    if (!headerResponse.ok) {
      Swal.fire({
      icon: '',
      title: 'Oops...',
      text: headerResponse.statusText,
      showConfirmButton: true,
      customClass: {
        popup: 'small-swal-popup',
        icon: 'hide-swal-icon'
      }
      });
    }

    if(headerResponse.ok){
      const headerResult = await headerResponse.json();
      //Console.log(headerResult)
      navigate(`/DraftOrder`, {state: {createdNumber: headerResult.no, documentType: headerResult.documentType, systemId: headerResult.systemId, documentDate: headerResult.documentDate}});
    }
  }


  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <span className="firsttab">
            <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <span style={{ whiteSpace: 'nowrap' }}>Request For Quotation</span>
            <span className="actions">
              <a class="btn btn-sm border-black action-btn" onClick={createDraftQuoteAndNavigateToDraft} role="button"> New Quotation</a>
            </span>
          </span>
          <div className="listTable">
            <CustTable/>
          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default DraftOrders;